export function ErrorIcon({ className }: { className?: string }) {
	return (<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={`text-current ${className}`}>
		<circle cx="13" cy="13" r="13" fill="currentColor" />
		<line x1="18.665" y1="8.02556" x2="8.01359" y2="18.4984" stroke="white" stroke-width="2" />
		<line x1="18.0693" y1="18.5373" x2="7.50676" y2="7.97481" stroke="white" stroke-width="2" />
	</svg>)
}